var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.FA=require("ttag");module.exports=$CLJS.FA;